/* ==========================================================================
   ACC_BN_LP_103 — Section 06: Ingredients accordion JS
   Each <details> item opens/closes independently AND animates both ways.
   Native <details> hides content instantly on close, so we drive the
   grid-template-rows animation via an `is-open` class and only flip the
   `open` attribute off after the closing transition finishes.
   ========================================================================== */
(function () {
  'use strict';

  function initItem(det) {
    if (det.__acc103Bound) return;
    det.__acc103Bound = true;

    var summary = det.querySelector('summary');
    var body = det.querySelector('.acc103-06__body');
    if (!summary || !body) return;

    // Sync initial state (items rendered with the `open` attribute).
    if (det.open) det.classList.add('is-open');

    summary.addEventListener('click', function (e) {
      e.preventDefault();

      if (det.open) {
        // ---- closing: animate, then remove `open` ----
        det.classList.remove('is-open');
        var onEnd = function (ev) {
          if (ev.target !== body || ev.propertyName !== 'grid-template-rows') return;
          body.removeEventListener('transitionend', onEnd);
          if (!det.classList.contains('is-open')) det.open = false;
        };
        body.addEventListener('transitionend', onEnd);
      } else {
        // ---- opening: render first, then animate ----
        det.open = true;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { det.classList.add('is-open'); });
        });
      }
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('.acc103-06__item').forEach(initItem);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Shopify theme editor re-render support
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) init(e.target);
  });
})();
